export default __webpack_public_path__ + "static/media/burgerMenu.0341946d.svg";